<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.title"
        placeholder="标题"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.type"
        placeholder="类型"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in NEWS_TYPE"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in NEWS_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button class="filter-item" type="primary" @click="clickNews('CREATE')"
        >新增</el-button
      >
    </div>

    <div style="margin-bottom: 5px">资讯数量:{{ total }}</div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column
        align="center"
        prop="id"
        label="ID"
        width="95"
      ></el-table-column>
      <el-table-column
        label="标题"
        align="center"
        prop="title"
      ></el-table-column>
      <el-table-column
        label="副标题"
        align="center"
        prop="subTitle"
        width="200px"
      ></el-table-column>
      <el-table-column label="内容" align="center" prop="content" width="300px">
        <template slot-scope="scope">
          <span v-html="scope.row.content" class="content_warp"></span>
        </template>
      </el-table-column>
      <el-table-column
        label="封面图"
        prop="coverImage"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-image
            style="width: 80px; height: 80px"
            :src="scope.row.coverImage"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="ctdate"
        label="媒体类型"
        width="100px"
      >
        <template slot-scope="scope">
          <span>{{ getValue(MEDIA_TYPE, scope.row.mediaType) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="浏览次数"
        align="center"
        prop="browses"
      ></el-table-column>
      <el-table-column
        label="赞次数"
        align="center"
        prop="ups"
      ></el-table-column>
      <el-table-column
        label="踩次数"
        align="center"
        prop="downs"
      ></el-table-column>
      <el-table-column
        label="收藏次数"
        align="center"
        prop="collects"
      ></el-table-column>
      <el-table-column align="center" prop="status" label="状态" width="200px">
        <template slot-scope="scope">
          <span>{{ getValue(NEWS_STATUS, scope.row.status) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="type" label="类型" width="200px">
        <template slot-scope="scope">
          <span>{{ getValue(NEWS_TYPE, scope.row.type) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="ctdate"
        label="创建时间"
        width="200px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="mddate"
        label="修改时间"
        width="200px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="clickNews('UPDATE', scope.row)"
            >编辑</el-button
          >
          <el-popconfirm
            confirm-button-text="好的"
            cancel-button-text="不用了"
            icon="el-icon-info"
            icon-color="red"
            title="确定修改该新闻状态吗？"
            @confirm="checkNewsStatus(scope.row)"
            style="margin: 0 8px;"
          >
            <el-button slot="reference" type="warning" size="mini"
              >切换新闻状态</el-button
            >
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { getNewsList, updateNewsStatus } from "@/api/news.js";
import { formatApiDate } from "@/utils/utils";
import {
  getValue,
  NEWS_TYPE,
  NEWS_STATUS,
  MEDIA_TYPE
} from "@/utils/enumUtile";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    NEWS_TYPE() {
      return NEWS_TYPE;
    },
    NEWS_STATUS() {
      return NEWS_STATUS;
    },
    MEDIA_TYPE() {
      return MEDIA_TYPE;
    }
  },
  components: {},
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        title: null,
        type: null
      }
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },

    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getNewsList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 跳转到新增 or 编辑
     */
    clickNews(type, row = {}) {
      this.shipmentVisible = status;
      if (type === "CREATE") {
        this.$router.push({ path: "/businessNews/save" });
      } else {
        this.$router.push({ path: "/businessNews/edit/" + row.id });
      }
    },

    /**
     * 切换活动状态
     */
    checkNewsStatus(item) {
      const params = {
        id: item.id,
        status: item.status === 0 ? 1 : 0
      };
      updateNewsStatus(params).then(resp => {
        if (resp && resp.bizcode === 100) {
          this.getList();
          this.$notify({
            title: "成功",
            message: "切换成功",
            type: "success",
            duration: 2000
          });
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
.content_warp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 限制文本显示为3行 */
  overflow: hidden;
  width: 280px; /* 你可以根据需要调整宽度 */
}
</style>
